/**
 * Clean-ups applied to the HTML Hygraph serialises for rich-text fields.
 *
 * Hygraph's `content { html }` writes a `title` attribute on every anchor and
 * fills it with the href when the editor left the Link's title field empty:
 *
 *   <a title="https://leisurecraft.com/barrel-sauna"
 *      href="https://leisurecraft.com/barrel-sauna">barrel sauna</a>
 *
 * The browser shows that as a tooltip on hover, so readers get the raw URL
 * floating over the text. It is also noise for screen readers, which may
 * announce the title instead of the link text. This is Hygraph's output, not
 * something our renderer adds, so it has to be stripped on the way in.
 */

/**
 * Drops `title` from anchors whose title merely repeats the href. A title the
 * editor actually wrote is left alone — legacy blog posts have one such link,
 * and stripping every title would lose it.
 */
export function stripRedundantLinkTitles(html) {
  if (!html) return html;

  return html.replace(/<a\b[^>]*>/gi, (tag) => {
    const href = tag.match(/\shref="([^"]*)"/i);
    const title = tag.match(/\stitle="([^"]*)"/i);
    if (!href || !title || href[1] !== title[1]) return tag;
    return tag.replace(/\stitle="[^"]*"/i, "");
  });
}
